import { Dispatch, AnyAction } from 'redux';

import { getActiveBeneficiaryMappingTasks } from '../apiClient';
import { warningAction, errorAction } from './notifications';
import { hasFeatureAccess, AuthState } from '../login/auth';
import { ManagerPermission } from '../permission-profiles/permission';

/**
 * Checks for active mapping tasks and displays a notification if there are any.
 * This function should be called when the user logs in and when the home page is viewed.
 *
 * @param auth The current auth state
 * @param dispatch The dispatch function from Redux
 */
export const checkActiveMappingTasks = (auth: AuthState, dispatch: Dispatch<AnyAction>): void => {
    // Only check if user has the permission to access mapping
    if (auth.manager && hasFeatureAccess(auth, ManagerPermission.beneficiaryMappingImport)) {
        getActiveBeneficiaryMappingTasks()
            .then((response) => {
                const hasActiveTasks =
                    (response.tasks && response.tasks.length > 0) ||
                    (response.batches && response.batches.some((batch) => batch.status === 'active'));

                if (hasActiveTasks) {
                    dispatch(warningAction('There are unfinished mapping tasks. Please complete the mapping process.'));
                }
            })
            .catch((error) => {
                dispatch(errorAction(error));
            });
    }
};
